import { Service, Project, Technology } from '../types';

export const services: Service[] = [
  {
    icon: '🔍',
    title: 'AI Business Assessment',
    description: 'An AI-guided assessment that maps your operations, identifies automation opportunities, and delivers a personalized report in 24 hours.',
    features: [
      'AI-guided assessment call',
      'Personalized tool recommendations',
      '4-day quick start action plan',
      'ROI & time savings projection'
    ],
    link: { label: 'Learn More →', url: '/assessment#how-it-works' },
    featured: true
  },
  {
    icon: '🤖',
    title: 'AI Strategies',
    description: 'Accelerate innovation with tailored AI and machine learning strategies for your business.',
    features: [
      'AI readiness assessments',
      'Azure OpenAI & Copilot integration',
      'ML model development & deployment',
      'Responsible AI governance'
    ],
    link: { label: 'Microsoft AI Strategy Roadmap', url: 'https://azurearchprodassess.blob.core.windows.net/public-documents/MSAI.pdf' }
  },
  {
    icon: '☁️',
    title: 'Azure Migration',
    description: 'Seamless transition to Azure cloud with zero downtime and optimized performance.',
    features: [
      'Infrastructure assessment & planning',
      'Workload migration strategies',
      'Data center modernization',
      'Post-migration optimization'
    ]
  },
  {
    icon: '🏗️',
    title: 'Azure Architecture',
    description: 'Design robust, scalable cloud architectures built for your business goals.',
    features: [
      'Solution architecture design',
      'Security & compliance planning',
      'High availability systems',
      'Cost optimization strategies'
    ]
  },
  {
    icon: '📋',
    title: 'Azure Planning',
    description: 'Strategic roadmaps for cloud adoption and digital transformation.',
    features: [
      'Cloud readiness assessments',
      'TCO & ROI analysis',
      'Governance frameworks',
      'Resource management planning'
    ]
  },
  {
    icon: '💻',
    title: 'Custom Development',
    description: 'Full-stack application development with modern frameworks and best practices.',
    features: [
      'Frontend web applications',
      'Backend API development',
      'Microservices architecture',
      'CI/CD pipeline setup'
    ]
  },
  {
    icon: '🔄',
    title: 'DevOps & Automation',
    description: 'Streamline development with Azure DevOps and automation solutions.',
    features: [
      'Infrastructure as Code (IaC)',
      'Container orchestration',
      'Automated deployments',
      'Monitoring & observability'
    ]
  },
  {
    icon: '🛡️',
    title: 'Security & Compliance',
    description: 'Implement enterprise security and meet regulatory requirements.',
    features: [
      'Identity & access management',
      'Network security design',
      'Compliance frameworks',
      'Security monitoring'
    ]
  }
];

export const projects: Project[] = [
  {
    icon: '🎓',
    title: 'College Roadmap App',
    description: 'AI-powered college planning platform guiding students through the entire admissions process with personalized roadmaps, deadlines, and expert resources.',
    tags: ['Education', 'AI/ML', 'React'],
    link: '/case-studies/college-roadmap.html',
    visitUrl: 'https://hischolar.ai'
  },
  {
    icon: '🏡',
    title: 'Realtor CT',
    description: 'Modern real estate web app for Connecticut agents — fast property listings, agent contact forms, and automated deployments on Azure Static Web Apps.',
    tags: ['Real Estate', 'React', 'Azure'],
    link: '/case-studies/realtor-ct.html',
    visitUrl: 'https://calm-smoke-0dddcc40f.2.azurestaticapps.net'
  },
  {
    icon: '🏥',
    title: 'Healthcare System Migration',
    description: 'Migrated legacy on-premises infrastructure to Azure, serving 500K+ patients with 99.9% uptime and HIPAA compliance.',
    tags: ['Azure', 'Migration', 'Healthcare'],
    link: '#'
  },
  {
    icon: '📊',
    title: 'Real-Time Analytics Platform',
    description: 'Custom dashboard application processing 10M+ events daily with Azure Functions and Cosmos DB backend.',
    tags: ['React', 'Node.js', 'Analytics'],
    link: '#'
  },
  {
    icon: '🏪',
    title: 'E-commerce Platform Modernization',
    description: 'Transformed monolithic application into microservices architecture on AKS, reducing costs by 40%.',
    tags: ['E-commerce', 'Microservices', 'Kubernetes'],
    link: '#'
  },
  {
    icon: '💰',
    title: 'Financial Services Cloud Infrastructure',
    description: 'Built secure, compliant Azure environment for financial transactions with SOC 2 Type II certification.',
    tags: ['FinTech', 'Security', 'Compliance'],
    link: '#'
  },
  {
    icon: '📱',
    title: 'IoT Device Management System',
    description: 'Developed full-stack solution managing 50K+ IoT devices with Azure IoT Hub and custom React Native app.',
    tags: ['Mobile', 'API', 'IoT'],
    link: '#'
  },
  {
    icon: '🎓',
    title: 'Learning Management Platform',
    description: 'Built scalable LMS with AI-powered recommendations serving 100K+ students across multiple institutions.',
    tags: ['Education', 'SaaS', 'AI/ML'],
    link: '#'
  }
];

export const technologies: Technology[] = [
  { icon: '☁️', name: 'Azure Cloud', url: 'https://azure.microsoft.com/' },
  { icon: '⚛️', name: 'React', url: 'https://react.dev/' },
  { icon: '📗', name: 'Node.js', url: 'https://nodejs.org/' },
  { icon: '🐍', name: 'Python', url: 'https://www.python.org/' },
  { icon: '#️⃣', name: '.NET', url: 'https://dotnet.microsoft.com/' },
  { icon: '🐳', name: 'Docker', url: 'https://www.docker.com/' },
  { icon: '☸️', name: 'Kubernetes', url: 'https://kubernetes.io/' },
  { icon: '📊', name: 'SQL/NoSQL', url: 'https://en.wikipedia.org/wiki/NoSQL' },
  { icon: '🤖', name: 'AI', url: 'https://azure.microsoft.com/en-us/solutions/ai/' },
  { icon: '🔧', name: 'Azure DevOps', url: 'https://azure.microsoft.com/en-us/services/devops/' },
  { icon: '🐙', name: 'GitHub', url: 'https://github.com/' },
  { icon: '🟠', name: 'Oracle', url: 'https://www.oracle.com/' },
  { icon: '⚡', name: 'Functions (serverless)', url: 'https://azure.microsoft.com/en-us/services/functions/' },
  { icon: '🐧', name: 'Linux', url: 'https://www.linux.org/' },
  { icon: '🪟', name: 'Windows', url: 'https://www.microsoft.com/en-us/windows/' }
];
